import { useEffect, useRef } from "react";

const ScrollAnimations = () => {
  // Use a ref instead of state for tracking animated elements to avoid re-renders
  const animatedElementsRef = useRef(new Set());

  useEffect(() => {
    // Function to check if an element is in viewport with some optimizations
    const isInViewport = (element) => {
      const rect = element.getBoundingClientRect();
      return (
        rect.top <=
        (window.innerHeight || document.documentElement.clientHeight) * 0.8
      );
    };

    // Function to handle scroll animation with throttling
    let ticking = false;
    const handleScrollAnimation = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const elements = document.querySelectorAll(".animate-on-scroll");

          elements.forEach((element) => {
            if (
              isInViewport(element) &&
              !animatedElementsRef.current.has(element)
            ) {
              element.classList.add("animated");
              animatedElementsRef.current.add(element);
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    };

    // Initial check for elements in viewport
    handleScrollAnimation();

    // Add passive scroll event listener for better performance
    window.addEventListener("scroll", handleScrollAnimation, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScrollAnimation);
    };
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default ScrollAnimations;
